import { render, staticRenderFns } from "./gl-pnldim.vue?vue&type=template&id=1c60a2c2&scoped=true"
import script from "./gl-pnldim.vue?vue&type=script&lang=js"
export * from "./gl-pnldim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60a2c2",
  null
  
)

export default component.exports